/* eslint-disable no-unused-vars */
import { useState } from 'react'

import { Autocomplete, TextField, CircularProgress } from '@mui/material'
import { Col, Row, Span } from 'components'
import Masker from 'hooks/useMasker'
import { Controller } from 'react-hook-form'
import { COLORS, SPACING } from 'utils'

import { makeStyles } from '@material-ui/styles'

import { CustomInput } from '../Input/styles'

// estilo para padronizar autocomplete com o input

const useStyles = makeStyles({
  root: {
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '0.1rem solid #004C97 !important'
    },
    '& .MuiInput-root:before': {
      borderBottom: '0.1rem solid #320f00'
    },
    '& .MuiInput-root:after': {
      borderBottom: '0.1rem solid #004C97'
    }
  }
})

//fim estilo

interface InputProps {
  noFilter?: boolean
  mask?: string[]
  control?: any
  errors?: any
  label?: string
  placeholder?: string
  formValue?: string
  valueName: string | number
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  marginTop?: string
  isOptionEqualToValue?: (param: string) => boolean
  //   | string
  required?: boolean
  disabled?: boolean
  defaultValue?: string
  options: object[]
  optionValue: string
  value?: string
  onChange?: (showValue, idValue) => void
  onInputChange?: (event: any, value?: string, reason?: string) => void
  onChangeText?: (event: React.ChangeEvent<HTMLInputElement>) => void
  inputIcon?: React.ReactNode
  onClickIcon?: () => void
  onBlur?: (selected: any) => void
  name?: string
  loading?: boolean
  inputValue?: string
  useOnBlur?: boolean
  type?: 'default' | 'dynamic'
  maxLength?: number
  width?: string
}
/*
 *************************************************
 *************************************************
 *************************************************

ATENÇÃO DEV ESSE COMPONENTE FOI DECLARADO COMO ENCERRADO SENDO
ASSIM ALTERAÇÕES SÃO PROIBIDAS. SE TIVER QUE FAZER ALGUMA ALTERAÇÃO NESSE
COMPONENTE PARA REALIZAR A SUA TELA CRIE OUTRO.

 *************************************************
 *************************************************
 *************************************************
 */
export const AutoCompleteInput: React.FC<InputProps> = ({
  noFilter,
  disabled,
  errors,
  isOptionEqualToValue,
  mask,
  useOnBlur = false,
  required,
  options,
  control,
  label = '',
  placeholder,
  marginTop,
  valueName,
  marginBottom,
  marginLeft,
  marginRight,
  formValue,
  value,
  defaultValue,
  optionValue,
  onChange,
  onChangeText,
  onBlur,
  maxLength,
  name,
  loading,
  type = 'default',
  width
}) => {
  const [valueAutocomplete, setValueAutocomplete] = useState(defaultValue || '')
  const hasError = errors ? errors[formValue] : null
  const classes = useStyles()
  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      {control ? (
        <Controller
          name={formValue}
          control={control}
          defaultValue={defaultValue || ''}
          render={({
            field: { onChange: controllerOnChange, value: controllerValue }
          }) => (
            <Autocomplete
              filterOptions={noFilter ? (options) => options : undefined}
              isOptionEqualToValue={isOptionEqualToValue}
              disablePortal
              disabled={disabled}
              value={type === 'default' ? valueAutocomplete : controllerValue}
              onChange={(_, value: string) => {
                const matchOption = options.find(
                  (option) => option[optionValue] == value
                )

                if (matchOption) {
                  setValueAutocomplete(value)
                  controllerOnChange(matchOption[valueName])

                  if (type === 'dynamic') {
                    // Callback da prop onChange quando seleciona uma opção na lista
                    onChange(matchOption[optionValue], matchOption[valueName])
                  }

                  return
                }

                if (type === 'dynamic') {
                  // Permite apagar o campo quando não for o tipo padrão
                  setValueAutocomplete('')
                  controllerOnChange('')
                  onChange('', 0)
                }
              }}
              onBlur={(event: any) => {
                if (type === 'dynamic') {
                  // Input com valor "opção" encontra "Opção"
                  const matchOption = options.find(
                    (option) =>
                      option[optionValue]?.toLowerCase() ===
                      event.target.value?.toLowerCase()
                  )
                  // Input com valor "opç" prevê "(Opç)ão 1" e "(Opç)ão 2"
                  const possibleOptions = options?.filter(
                    (option) =>
                      option[optionValue]
                        ?.toLowerCase()
                        ?.indexOf(event.target.value.toLowerCase()) > -1
                  )

                  // O texto todo do input deu match com uma opção da lista
                  if (matchOption) {
                    controllerOnChange(matchOption[valueName])
                    onChange(matchOption[optionValue], matchOption[valueName])
                    return
                  }

                  // Uma parte do input deu match com pelo menos uma opção, seleciona
                  // automaticamente a primeira opção da lista quando tira o foco
                  // do input sem terminar de escrever
                  if (possibleOptions.length > 0 && controllerValue) {
                    controllerOnChange(options[0][valueName])
                    onChange(options[0][optionValue], options[0][valueName])
                    return
                  }

                  // Reseta o input caso não encontre nada
                  controllerOnChange('')
                  onChange('', 0)
                }
              }}
              options={
                (options?.length > 0 &&
                  options.map((option) => option[optionValue] || '')) ||
                []
              }
              renderInput={(params) => (
                <>
                  <CustomInput
                    {...params}
                    name={name ? name : formValue}
                    label={label}
                    hasError={!!hasError}
                    error={!!hasError}
                    variant="standard"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      if (type === 'dynamic') {
                        onChangeText(event)
                        // Persiste o valor digitado mesmo quando não seleciona uma opção
                        controllerOnChange(event.target.value)
                      }
                    }}
                    inputProps={{ ...params.inputProps, maxLength: maxLength }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading && (
                            <CircularProgress color="inherit" size={20} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      )
                    }}
                  />
                  {!!hasError && (
                    <Row marginTop={SPACING.spacing5}>
                      <Span
                        text={errors[formValue]?.message || 'Erro'}
                        color={COLORS.error}
                      />
                    </Row>
                  )}
                </>
              )}
              // Essa prop troca o texto "no options" ao não encontrar auto-complete
              noOptionsText={'Nada encontrado'}
              // Essa prop abaixo por algum motivo corrige bugs ao apagar o input
              // tanto no "X" quanto manualmente, mas a função original é não mostrar
              // "no options" quando não encontrar nenhum auto-complete
              // freeSolo={true}
            />
          )}
          rules={{ required }}
        />
      ) : (
        <>
          <Autocomplete
            filterOptions={noFilter ? (options) => options : undefined}
            disabled={disabled}
            disablePortal
            value={value || ''}
            onChange={(event, value) => {
              const selectValue = options.find((option) => {
                const findValue = mask
                  ? Masker(option[optionValue], mask)
                  : option[optionValue]
                return findValue == value
              })

              if (selectValue) {
                onChange(selectValue[optionValue], selectValue[valueName])
              } else {
                onChange('', 0)
              }
            }}
            options={
              (options?.length > 0 &&
                options.map((option) =>
                  mask
                    ? Masker(option[optionValue], mask)
                    : option[optionValue] || ''
                )) ||
              []
            }
            renderInput={(params) => (
              <TextField
                placeholder={placeholder}
                {...params}
                error={hasError || null}
                name={name}
                onChange={onChangeText}
                onBlur={
                  useOnBlur
                    ? (e) => {
                        const selectValue = options.find(
                          (option) => option[optionValue] == e.target.value
                        )

                        onBlur(selectValue[valueName])
                      }
                    : null
                }
                className={classes.root}
                style={{ width: width }}
                label={label ? label : null}
                variant="standard"
                inputProps={{ ...params.inputProps, maxLength: maxLength }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            )}
            // Essa prop troca o texto "no options" ao não encontrar auto-complete
            noOptionsText={'Nada encontrado'}
            // Essa prop abaixo por algum motivo corrige bugs ao apagar o input
            // tanto no "X" quanto manualmente, mas a função original é não mostrar
            // "no options" quando não encontrar nenhum auto-complete
            // freeSolo={true}
          />
          {hasError && (
            <Span text={hasError?.message || 'Erro.'} color={COLORS.error} />
          )}
        </>
      )}
    </Col>
  )
}
